import { config } from "../../../../../auth/Office365Config";
import { UserAgentApplication } from "msal";
import Context from "../../../../../context/Context";
import * as shareUtil from "../../../../../../src/components/main/InfoPanel/shareUtil";
const graph = require('@microsoft/microsoft-graph-client')
export default class Office365 {
  static instance

  constructor() {
    const currentURI = window.location.href.split('?')[0]
    // Check configurator
    const configuration = Context.instance.configuration
    const configurables = configuration.extractConfigurables()
    const appId = configurables.officeHoteling && configurables.officeHoteling.appId
    this.userAgentApplication = new UserAgentApplication({
      auth: {
        clientId: appId,
        redirectUri: currentURI,
        postLogoutRedirectUri: currentURI
      },
      cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true
      }
    })
    const params = this.getUrlParams()
    if (params) {
      Object.keys(params).forEach(key => {
        this.setCookie(key, params[key], 1)
      })
    }
  }

  updateAppId(appId) {
    const currentURI = window.location.href.split('?')[0]
    this.userAgentApplication = new UserAgentApplication({
      auth: {
        clientId: appId,
        redirectUri: currentURI,
        postLogoutRedirectUri: currentURI
      },
      cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true
      }
    })
  }

  getUrlParams = () => {
    let params = {}
    let url = window.location.href
    let excludeURI = url.split('?')
    if (excludeURI.length > 1) {
      let vars = excludeURI[1].split('&')
      for (var i = 0; i < vars.length; i++) {
        let pair = vars[i].split('#')[0].split('=')
        if (!pair[0].includes('msal')) {
          params[pair[0]] = decodeURIComponent(pair[1])
        }
      }
      return params
    }
    return null
  }

  setCookie = (cname, cvalue, exdays) => {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  static getInstance() {
    if (!this.instance) {
      this.instance = new Office365()
    }
    return this.instance
  }

  getLoggedInUser = () => {
    return this.userAgentApplication.getAccount()
  }

  login = () => {
    return new Promise((resolve, reject) => {
      const loginRequest = {
        scopes: config.scopes
      }

      const authCallback = (error, response) => {
        if (response) {
          resolve(response)
        }
        else {
          reject(error)
        }
      }
      this.userAgentApplication.handleRedirectCallback(authCallback)
      const tryRedirect = () => {
        return this.userAgentApplication.loginRedirect(loginRequest)
      }

      this.userAgentApplication.loginPopup(loginRequest)
        .then(function (loginResponse) {
          resolve("Success")
        }).catch(function (error) {
          tryRedirect()
        })
    })
  }

  getAccessToken = () => {
    return new Promise((resolve, reject) => {
      const accessTokenRequest = {
        scopes: config.scopes
      }
      const authCallback = (error, response) => {
        if (response) {
          console.log(response)
          if (!response.accessToken) {
            this.userAgentApplication.acquireTokenSilent(accessTokenRequest).then(function(accessTokenResponse) {
              resolve(accessTokenResponse)
            }).catch(e => {
              console.log(e)
              reject(e)
            })
          } else {
            resolve(response)
          }
        }
        else {
          console.log(error)
          reject(error)
        }
      }
      this.userAgentApplication.handleRedirectCallback(authCallback)

      const tryPopup = () => {
        return this.userAgentApplication.acquireTokenPopup(accessTokenRequest)
      }

      const tryRedirect = () => {
        return this.userAgentApplication.acquireTokenRedirect(accessTokenRequest)
      }

      this.userAgentApplication.acquireTokenSilent(accessTokenRequest).then(function(accessTokenResponse) {
        resolve(accessTokenResponse)
      }).catch(function (error) {
        tryPopup().then(function(accessTokenResponse) {
          resolve(accessTokenResponse)
        }).catch(function (error) {
          tryRedirect()
        })
      })
    })
  }

  getAuthenticatedClient = (accessToken) => {
    const client = graph.Client.init({
      debugLogging: true,
      authProvider: (done) => {
        done(null, accessToken.accessToken)
      }
    });

    return client;
  }

  getBookingSchedule = (accessToken, params) => {
    return new Promise((resolve, reject) => {
      console.log(accessToken)
      const client = this.getAuthenticatedClient(accessToken)

      const scheduleInformation = {
        schedules: params.schedules,
        startTime: params.startTime,
        endTime: params.endTime
      }
      console.log(scheduleInformation, client)

      client.api('/me/calendar/getSchedule')
        .post(scheduleInformation)
        .then(user => {
          resolve(user)
        }).catch(e => {
          reject(e)
        });
    })
  }

  areEmailsAvailable = (scheduleEmails, checkIn, checkOut) => {
    return new Promise((resolve, reject) => {
      this.getAccessToken().then(token => {
        if (token && checkIn && checkOut) {
          const BATCH_SIZE = 15
          const CONCURRENT_REQUESTS = 4

          let chunks = []
          for (var i = 0; i < scheduleEmails.length; i += BATCH_SIZE) {
            chunks.push(scheduleEmails.slice(i, i + BATCH_SIZE))
          }

          let stack = []
          chunks.forEach(chunk => {
            stack.push(chunk)
          })

          let promises = []
          let needPromisesHandler = true
          let finalResults = []

          console.log("STACK", stack)
          const processNextBatch = () => {
            if (stack.length !== 0) {
              let nextEmails = stack.pop()
              const params = {
                schedules: nextEmails,
                startTime: {
                  dateTime: checkIn,
                  timeZone: "UTC"
                },
                endTime: {
                  dateTime: checkOut,
                  timeZone: "UTC"
                }
              }
              let promise = new Promise((res, rej) => {
                this.getBookingSchedule(token, params).then(availableUnits => {
                  console.log(availableUnits)
                  res(availableUnits)
                }).catch(e => {
                  console.log(e)
                  reject(e)
                  rej(e)
                }).finally(() => {
                  processNextBatch()
                })
              })
              promises.push(promise)
            } else if (needPromisesHandler) {
              needPromisesHandler = false
              Promise.all(promises).then(availableUnits => {
                if (availableUnits.error) {
                  reject()
                } else {
                  availableUnits.forEach(unit => {
                    finalResults.push([].concat.apply([], unit.value))
                  })
                  resolve(finalResults)
                }
              }).catch(e => {
                console.error(e)
              })
            }
          }

          for (var j = 0; j < CONCURRENT_REQUESTS; j++) {
            processNextBatch()
          }
        } else if (!token) {
          console.error("No token")
        }
      }).catch(e => {
        console.error(e)
        reject(e)
      })
    })
  }

  getTimeZone = async(accessToken)=>{
    const client = this.getAuthenticatedClient(accessToken);
    const response = await client.api('me/mailboxSettings/timeZone').get();
    return response;
  }

  bookWorkspace = async (accessToken, email, unitName, checkInDate, checkOutDate, item) =>{
    const scheduleEmail = email;
    const client = this.getAuthenticatedClient(accessToken);
    const timezone = await this.getTimeZone(accessToken);
    if(timezone === undefined || timezone === null) timezone = "UTC";
    const epochStartDateTime = new Date(checkInDate).getTime();
    const epochEndDateTime = new Date(checkOutDate).getTime();
    let hoursDiff = (epochStartDateTime - epochEndDateTime)/1000;
    hoursDiff /= (60*60);
    hoursDiff = Math.abs(hoursDiff);
    let reminderHours;
    if(hoursDiff <= 24) reminderHours = 3*60;
    else reminderHours = 18*60;

    const i18n = Context.instance.i18n;
    const subject = i18n.more.bookWorkspace.emailSubject.replace("{workspaceName}", unitName);
    const location = shareUtil.generateShareUrl(item);
    const locationLink = i18n.more.bookWorkspace.locationLinkPattern;
    const locale = Context.instance.lib.dojo.kernel.locale;
    if (locale === "en" || locale === "en-us") {
      this.use12Hours = true
      this.format = "h:mm A"
    } else {
      this.use12Hours = false
      this.format = "H:mm"
    }
    const startDate = Context.instance.lib.dojo.locale.format(checkInDate, {
      selector: "date",
      datePattern: "yyyy/MM/dd"
    })
    const startTime = Context.instance.lib.dojo.locale.format(checkInDate, {
      selector: "time",
      timePattern: "HH:mm:ss"
    })
    const endDate = Context.instance.lib.dojo.locale.format(checkOutDate, {
      selector: "date",
      datePattern: "yyyy/MM/dd"
    })
    const endTime = Context.instance.lib.dojo.locale.format(checkOutDate, {
      selector: "time",
      timePattern: "HH:mm:ss"
    })

    const startDateTime = startDate + "T" + startTime;
    const endDateTime = endDate + "T" + endTime;

    const content = '<div><a href=\"'+ location +'\">'+locationLink+'</a></div>';

    const event = {
      subject: subject,
      body: {
        contentType: "HTML",
        content: content
      },
      start: {
          dateTime: startDateTime,
          timeZone: timezone.value
      },
      end: {
          dateTime: endDateTime,
          timeZone: timezone.value
      },
      location:{
          displayName: unitName
      },
      attendees: [
        {
          emailAddress: {
            address: scheduleEmail,
            name: unitName
          }
        }
      ],
      isOrganizer: true,
      isReminderOn: true,
      reminderMinutesBeforeStart: reminderHours,
      showAs: "free",
      allowNewTimeProposals: true
    };

    const response = await client.api('/me/calendar/events').post(event);
    return response;    
  }

  logout = () => {
    window.open(window.location.href)
    this.userAgentApplication.logout()
  }
}
